// Save references to original console methods
const originalConsole = {
  log: console.log,
  error: console.error,
  warn: console.warn,
  info: console.info,
  debug: console.debug,
  trace: console.trace,
};

// Function to get formatted timestamp
const getTimestamp = () => {
  const now = new Date();
  return now.toLocaleString("sv-SE");
};

const applyConsoleMethodsPatch = () => {
  // Patch console methods
  console.log = (...args) => {
    originalConsole.log(`[${getTimestamp()}]:`, ...args);
  };

  console.error = (...args) => {
    originalConsole.error(`[${getTimestamp()}] ERROR:`, ...args);
  };

  console.warn = (...args) => {
    originalConsole.warn(`[${getTimestamp()}] WARN:`, ...args);
  };

  console.info = (...args) => {
    originalConsole.info(`[${getTimestamp()}] INFO:`, ...args);
  };

  console.debug = (...args) => {
    originalConsole.debug(`[${getTimestamp()}] DEBUG:`, ...args);
  };

  console.trace = (...args) => {
    originalConsole.trace(`[${getTimestamp()}] TRACE:`, ...args);
  };
};

const restoreConsole = () => {
  Object.assign(console, originalConsole);
};

export {
  originalConsole,
  getTimestamp,
  applyConsoleMethodsPatch,
  restoreConsole,
};
